import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { CollectionsSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { RouterError } from '../../bootstrap/routerHelpers/RouterError';
import { AllCollectionsSpaceProvider } from './AllCollectionsSpaceProvider';
import { CollectionSpaceProvider, CollectionSpaceProviderProps } from './CollectionSpaceProvider';

export interface CollectionsSpaceRouterOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
}

export interface CollectionsSpaceRouteParams {
  readonly luid: string;
}

export interface CollectionsSpaceRouteComponentProps extends RouteComponentProps<CollectionsSpaceRouteParams> {}

export interface CollectionsSpaceRouterStateProps {
  readonly previousUrl: string;
}

export type CollectionsSpaceRouterProps =  CollectionsSpaceRouterOwnProps & CollectionsSpaceRouterStateProps;

export class CollectionsSpaceRouter extends React.Component<CollectionsSpaceRouterProps> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.allCollectionsPath()} render={this.provider('all')} />
        <Route exact path={this.props.urls.myCollectionsPath()} render={this.provider('my')} />
        <Route path={this.props.urls.collectionGrantAccessPath(':luid')} render={({ match }) => (
          <Redirect to={this.props.urls.collectionPath(match.params.luid)} />
        )} />
        <Route
            exact path={this.props.urls.collectionPath(':luid')}
            render={this.collectionSpaceProvider(this.props)}
        />
        <Route exact path={this.props.urls.collectionsPath()} render={() => (
          <Redirect to={this.props.urls.allCollectionsPath()} />
        )} />
        <Route render={this.error}/>
      </Switch>
    );
  }

  private error = (_props: RouteComponentProps): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  };

  private collectionSpaceProvider = (providerProps: CollectionsSpaceRouterProps): (props: CollectionsSpaceRouteComponentProps) => JSX.Element => {
    return (props: CollectionsSpaceRouteComponentProps): JSX.Element => {
      const collectionLuid = props.match.params.luid;
      const grantAccessDisplay = this.props.previousUrl.includes(this.props.urls.collectionGrantAccessPath(collectionLuid));
      const collectionSpaceProviderProps: CollectionSpaceProviderProps = {
        siteName: this.props.siteName,
        routeLocationSearch: props.location.search,
        routeLocationPath: props.location.pathname,
        urls: providerProps.urls,
        collectionLuid: collectionLuid,
        grantAccessDisplay: grantAccessDisplay,
        grantAccessUrl: grantAccessDisplay ? this.props.previousUrl : '',
      };
      return <CollectionSpaceProvider {...collectionSpaceProviderProps} />;
    };
  };

  private provider = (subspaceName: CollectionsSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (routeProps): JSX.Element => {
      return <AllCollectionsSpaceProvider
        routeLocationPath={routeProps.location.pathname}
        routeLocationSearch={routeProps.location.search}
        subspaceName={subspaceName}
        urls={this.props.urls}
      />;
    };
  };
}
